import React, { Component } from 'react';
import PropTypes from "prop-types";
import "./ColorMaps.css";

import { withTranslation } from 'react-i18next';

class ColorMaps extends Component {
    
    constructor(props) {
        super(props);
        this.state = {  
            colorMapImages: [],
            colorMapDefault: "",
            colorMapSelected: "",        
        };
    }

    componentDidMount = () => {
        const { colorMapList,} = this.props;
        this.getColorMapImage(colorMapList);
    }

    // get ColorMap list
    getColorMapImage = async (colorMaps) => {
        const { fetchImage } = this.props
        let colorMapI = [];
        colorMaps.map(async (colorMap, i) =>  {
            try { 
                const imageData = await fetchImage("/colormaps/" + colorMap.name + "/png/") ;
                colorMapI[i] = imageData;
                this.setState({ colorMapImages: colorMapI });
            } catch (err) {
                console.log(err);
            }
        });

    }

    render() {
        const {
            handleColorMapSelected,
            colorMapSelected,
            colorMapList,
            t
        } = this.props;

        const { colorMapImages } = this.state;

        return (
            <div className="colorMapsList">
                <span className="colorHeader"> {t("Select color map")} </span> <br/>
                {colorMapList.map((colorMap, i) =>
                    <div className={colorMapSelected !== colorMap.name ? "colorMapImage" : "colorMapImageSelected" } key={colorMap.name} 
                        onClick={() => { handleColorMapSelected(colorMap)}}>
                        <span className="colorName"> {colorMap.name} </span> <br /> 
                        <img className="contentImage" src={colorMapImages[i]} alt={i} />
                            
                    </div>  
                )}
            </div>
        );
    }
}

export default withTranslation()(ColorMaps)

ColorMaps.propTypes = {

};
